var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "bl-client-targets bg-slate-200" },
    [
      _c("TargetPanel", {
        attrs: {
          id: _vm.id,
          newTargetOpened: _vm.newTargetOpened,
          taskOfTarget: _vm.taskOfTarget,
          activeTask: _vm.activeTask
        },
        on: {
          "toggle-active-task": _vm.toggleActiveTask,
          "toggle-task-target-opened": _vm.toggleTaskTargetOpened,
          "toggle-new-target-opened": _vm.toggleNewTargetOpened,
          "toggle-target-loading": _vm.toggleTargetLoading
        }
      }),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "bl-target-details" },
        [
          _vm.targetLoading
            ? _c("div", { staticClass: "absolute z-20 w-full h-full" }, [
                _c("div", {
                  staticClass:
                    "absolute w-full h-full opacity-75 bg-pure-white rounded-3xl"
                }),
                _vm._v(" "),
                _vm._m(0)
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm.target
            ? _c("TargetProperty", {
                attrs: {
                  target: _vm.target,
                  taskTarget: _vm.activeTask,
                  graphEntries: _vm.graphEntries,
                  entries: _vm.entries
                },
                on: {
                  updateTaskTarget: _vm.updateTaskTarget,
                  "select-task": _vm.selectTask
                }
              })
            : _c(
                "div",
                { staticClass: "bl-target-details-panel-empty text-grey-400" },
                [
                  _vm.totalTargets
                    ? _c(
                        "div",
                        { staticClass: "bl-target-details-message" },
                        [
                          _c("BlTextBody1", {
                            attrs: {
                              text: "Click the target card to view the details."
                            }
                          })
                        ],
                        1
                      )
                    : _c(
                        "div",
                        { staticClass: "bl-target-details-message" },
                        [
                          _c("BlTextBody1", {
                            attrs: {
                              text:
                                "Currently, there are no targets to display. Once you create a new"
                            }
                          }),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass:
                                "flex items-center justify-center gap-1 text-center"
                            },
                            [
                              _c("BlTextBody1", {
                                attrs: { text: "target, it will appear here." }
                              }),
                              _vm._v(" "),
                              _c("BlInputButton", {
                                staticClass:
                                  "p-0 bl-target-details-message-highlight",
                                attrs: {
                                  label: "Create a new target.",
                                  type: "plain"
                                },
                                on: {
                                  clicked: function($event) {
                                    return _vm.toggleNewTargetOpened(true)
                                  }
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      )
                ]
              )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      { staticClass: "absolute z-20 grid w-full h-full place-items-center" },
      [_c("div", { staticClass: "blum-loader" })]
    )
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-0b72b893", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0b72b893","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/clients/ClientTarget.vue
// module id = null
// module chunks = 